import {Pipe, PipeTransform} from '@angular/core';
import {FormAllData} from '../../interfaces/forms/form-element';

@Pipe({
  name: 'getFieldData',
  standalone: true,
})
export class GetFieldDataPipe implements PipeTransform {
  transform(field: string, data: FormAllData[]): FormAllData | undefined {
    return data.find((el) => el.name === field);
  }
}
